import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { correctSound } from "../../utils/Sounds";
import { TC_CHECK_CIRCLE_SVG } from "../../utils/tc_svgs";
import { AppIcon } from "../Generic/AppIcon";

const TrainingCenterVideoEngagementQuestionResultSuccess = () => {
  correctSound.play();

  return (
    <div className="TrainingCenterVideoEngagementQuestionResultSuccess">
      <AppIcon icon={TC_CHECK_CIRCLE_SVG} />
      <span>{translate(STRINGS.YOUR_ANSWER_IS_CORRECT)}</span>
    </div>
  );
};

export default React.memo(TrainingCenterVideoEngagementQuestionResultSuccess);
